import { render, staticRenderFns } from "./StepButtonsTherapy.vue?vue&type=template&id=4297817c&scoped=true&"
import script from "./StepButtonsTherapy.vue?vue&type=script&lang=js&"
export * from "./StepButtonsTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297817c",
  null
  
)

export default component.exports